import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../Common';
import ValidatedSelect from '../../common/forms/ValidatedSelect';
import { FormContext } from '../../common/forms/FormElements';

const toProjectOptions = (data) => (data ?? []).map((p) => ({
    value: p.value,
    label: p.workOrderNumber ? `${p.label} — WO#: ${p.workOrderNumber}` : p.label,
}));

export const Project = ({ onProjectChanged }) => {
    const { values } = useContext(FormContext);
    const { contractId } = values;

    const { data: options, isLoading } = useQuery({
        queryKey: ['openRentalProjectsByContract', contractId],
        queryFn: () => httpClient.js(ApiRoutes.typeAheads.openRentalProjectsByContract(contractId)),
        enabled: !!contractId,
        select: toProjectOptions,
    });

    return (
        <ValidatedSelect
            id="projectId"
            name="projectId"
            label="Project"
            options={options ?? []}
            isLoading={isLoading}
            isDisabled={!contractId}
            required
            error="A project is required."
            onChange={(selected) => onProjectChanged(selected?.value ?? null, contractId)}
        />
    );
};
